import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { Link } from "../../lib/Link";
import { TopBanner } from "../../common/TopBanner";

export const beginner = type => {
  document.title =
    "トランクルームをお探しなら『ハローストレージ』【公式】｜初めての方へ";
  return (
    <div className="container">
      {breadcrumbs(type, [{ text: "初めての方へ" }])}
      
      <div className="beginner_contents">
        <div className="main">
          <div className="pc">
            <img
              src="resource/img/static/beginner/kitty.png"
              className="image"
            />
            <img
              src="resource/img/static/beginner/pc-beginner_main.png"
              className="image"
            />
            <h1>初めての方へ</h1>
            <p className="catch">
              ただ収納するだけじゃない。
              <br /> 1人1人にあったそれぞれの使い方があります。
              <br /> あなたはトランクルームでどんな生活を送りますか？
            </p>
          </div>
          <div className="sp">
            <img src="resource/img/static/beginner/sp-beginner.png" />
            <img src="resource/img/static/beginner/sp-beginner1.png" />
            <h1>初めての方へ</h1>
            <p className="catch">
              ただ収納するだけじゃない。
              <br /> 1人1人にあった
              <br /> それぞれの使い方があります。
              <br /> あなたはトランクルームで
              <br /> どんな生活を送りますか？
            </p>
          </div>
          <div className="width">
            <div className="cases">
              <div className="pc">
                <img
                  src="resource/img/static/beginner/background-solid.png"
                  className="background"
                />
              </div>
              <Link to="/beginner/case1/"
                className="not-hover"
              >
                <img
                  src="resource/img/static/beginner/beginner_case1-v2.jpg"
                  alt="大人の書斎"
                  className="example"
                />
              </Link>
              <div className="sample1">
                <h3>大人の書斎</h3>
                <p>あなただけの専用図書館</p>
              </div>
              <div className="text-box">
                <p>
                  大切な書籍や洋服、思い出が詰まった大切な品々を、
                  <br className="pc" />
                  自宅にしまい込んだままにしていませんか？
                  <br />
                  トランクルームがあれば、目に触れなくなり風化しがちな
                  <br className="pc" />
                  思い出の品を、すぐに手に取ることも目で楽しむことができます。
                  <br />
                  過去から思い出をとりだして、いつまでも新鮮な、
                  <br className="pc" />
                  あなた好みのインテリアとして飾ってあげましょう。
                </p>
                <ul className="cases-btn">
                  <li>
                  <Link to="/beginner/case1/" className="seeing">
                    もっと見る
                  </Link>
                  </li>
                  <li>
                  <Link to="/list/" className="finding">
                    いますぐ探す
                  </Link>
                  </li>
                </ul>
                <br clear="left" />
              </div>
            </div>
            <div className="cases">
              <div className="pc">
                <img
                  src="resource/img/static/beginner/background-solid.png"
                  className="background"
                />
              </div>
              <Link to="/beginner/case1/"
                className="not-hover"
              >
                <img
                  src="resource/img/static/beginner/beginner_case2-v2.jpg"
                  alt="ショールーム"
                  className="example"
                />
              </Link>
              <div className="sample2">
                <h3>ショールーム</h3>
                <p>大好きなものたちに囲まれて</p>
              </div>
              <div className="text-box">
                <p>
                  プラモデル、ミニカー、モデルガンなど、自宅に保管している
                  <br className="pc" />
                  コレクション達をトランクルームにディスプレイすれば、
                  <br className="pc" />
                  この世でたった一つの、あなた専用ショールームができあがり。
                  <br />
                  空調つきの物件もご用意していますので、
                  <br className="pc" />
                  大切なコレクションを安全に収納することができます。
                </p>
                <ul className="cases-btn">
                  <li>
                    <Link to="/beginner/case2/" className="seeing">
                      もっと見る
                    </Link>
                  </li>
                  <li>
                  <Link to="/list/" className="finding">
                    いますぐ探す
                  </Link>
                  </li>
                </ul>
                <br clear="left" />
              </div>
            </div>
            <div className="cases">
              <div className="pc">
                <img
                  src="resource/img/static/beginner/background-solid.png"
                  className="background"
                />
              </div>
              <Link to="/beginner/case1/"
                className="not-hover"
              >
                <img
                  src="resource/img/static/beginner/beginner_case3.jpg"
                  alt="チェックポイント"
                  className="example"
                />
              </Link>
              <div className="sample3">
                <div className="pc">
                  <h3>チェックポイント</h3>
                  <p>アクティビティに大活躍の中継基地</p>
                </div>
                <div className="sp">
                  <h3>チェックポイント</h3>
                  <p>アクティビティに大活躍の<br/>中継基地</p>
                </div>
              </div>
              <div className="text-box">
                <p>
                  キャンプ、登山、ロードバイク、など、ブームの兆しを見せる
                  <br className="pc" />
                  アウトドア趣味の数々。
                  <br />
                  最新モデルや新アイテムをゲットしたら心踊りますよね。
                  <br />
                  ただそのアイテム、全て家の中に置いておかないといけませんか？
                  <br />
                  トランクルームに収納すれば、スペース補充としてだけではなく、
                  <br className="pc" />
                  お出かけ前のチェックポイントとしても活用できます。
                </p>
                <ul className="cases-btn">
                  <li>
                    <Link to="/beginner/case3/" className="seeing">
                      もっと見る
                    </Link>
                  </li>
                  <li>
                  <Link to="/list/" className="finding">
                    いますぐ探す
                  </Link>
                  </li>
                </ul>
                <br clear="left" />
              </div>
            </div>
          </div>
          <div className="storage">
            <div className="content cf">
              <div className="content_box">
                <h3>収納動画</h3>
                <div className="text-box">
                  <p>
                    収納スペースのサイズを選ぶことで、どのくらいの量の荷物が収納できるのか、動画で見ることができます。
                    さらに「同じ広さのトランクルームを探す」ボタンから収納スペースを直接探すこともできます。
                  </p>
                  <img
                    src="resource/img/static/beginner/beginner_storage.jpg"
                    alt="収納動画"
                    className="sp"
                  />
                  <ul className="cases-btn">
                    <li>
                      <Link to="/beginner/movie/" className="seeing">
                        もっと見る
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="pc">
                <img
                  src="resource/img/static/beginner/background-solid.png"
                  className="background"
                />
              </div>
              <img
                src="resource/img/static/beginner/beginner_storage.jpg"
                alt="収納動画"
                className="pc"
              />
            </div>
          </div>
          <div className="simulation">
            <div className="content cf">
              <div className="content_box">
                <h3>収納シミュレーション</h3>
                <div className="text-box">
                  <p>お客様のお荷物の容量から、該当する収納スペースのサイズをご確認いただくことができます。またシミュレーター内の荷物アイコンを選択することで、「このサイズの物件を探す」ボタンをクリックするとお客様の選択した荷物量に応じたサイズの部屋を探すことが出来ます。</p>
                  <img
                    src="resource/img/static/beginner/beginner_simulation_sp.jpg"
                    alt="収納シミュレーション"
                    className="sp"
                  />
                  <ul className="cases-btn">
                    <li>
                      <Link to="/simulator/" className="seeing">
                        もっと見る
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="pc">
                <img
                  src="resource/img/static/beginner/background-solid.png"
                  className="background"
                />
              </div>
              <img
                src="resource/img/static/beginner/beginner_simulation.jpg"
                alt="収納シミュレーション"
                className="pc"
              />
            </div>
          </div>
          <div className="width">
            <div className="information">
              <div className="pc">
                <Link to="/lineup/" className="textArea">
                  <img src="resource/img/static/beginner/lineup.png" />
                  <span>
                    商品ラインナップは
                    <br />
                    こちら
                  </span>
                </Link>
                <Link to="/flow/" className="textArea">
                  <img src="resource/img/static/beginner/flow.png" />
                  <span>
                    お申し込みから
                    <br />
                    ご契約の流れまで
                  </span>
                </Link>
                <Link to="/voice2/" className="textArea">
                  <img src="resource/img/static/beginner/voice.png" />
                  <span>
                    実際の
                    <br />
                    お客様の声
                  </span>
                </Link>
              </div>
              <div className="sp">
                <Link to="/lineup/" className="text1">
                  <img src="resource/img/static/beginner/lineup_sp.png" />
                  <span>
                    商品ラインナップは
                    <br />
                    こちら
                  </span>
                </Link>
                <Link to="/flow/" className="text2">
                  <img src="resource/img/static/beginner/flow_sp.png" />
                  <span>
                    お申し込みから
                    <br />
                    ご契約の流れまで
                  </span>
                </Link>
                <Link to="/voice2/" className="text3">
                  <img src="resource/img/static/beginner/voice_sp.png" />
                  <span>
                    実際の
                    <br />
                    お客様の声
                  </span>
                </Link>
              </div>
              <br className="left" />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/new/beginner.jsx